import paths from 'routing/routes/_paths';

import Routes from 'views/routes';

const routes = [
  {
    type: 'private',
    exact: true,
    app: true,
    path: paths.routes,
    component: Routes,
    documentTitle: 'Integrations'
  }
];

export default routes;
